import request from '@/utils/request';
export function onBatchSendRegisterPayBook(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchSendRegisterPayBook',
    method: 'post',
    data: data
  });
}

//查询补正书详情
export function getCaseCorrectionContent(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/findByCaseId/' + data,
    method: 'get'
  });
}
//caseBatchHandle/updateReview
export function onCaseBatchHandleUpdateReview(data) {
  return request({
    url: '/batchCase/caseBatchHandle/updateReview',
    method: 'post',
    data: data
  });
}
;

// caseArbitrator / findArbitratorByCaseId / { caseId }
export function onfindArbitratorByCaseId(data) {
  return request({
    url: '/batchCase/caseArbitrator/findArbitratorByCaseId/' + data,
    method: 'get'
  });
}
;

//补正书、、caseCorrectionContent/saveFile
export function onCorrectSaveFile(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/saveFile',
    method: 'post',
    data: data
  });
}
;
export function getCaseCorrectionContentNextProcess(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/findNextProcess/' + data,
    method: 'get'
  });
}
export function caseCorrectionContentAuit(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/audit',
    method: 'post',
    data: data
  });
}
//保存补正书
export function saveCaseCorrectionContent(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/save',
    method: 'post',
    data: data
  });
}

//查询补正书分页
export function getCaseCorrectionContentPage(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/findListByPage',
    method: 'post',
    data: data
  });
}

//送达类型 1 立案送达 2 组庭送达 3 开庭送达 4 裁决送达 5 结案 99.补正书送达
export function sendserviceType(data) {
  return request({
    url: '/batchCase/caseCorrectionContent/send',
    method: 'post',
    data: data
  });
}

// 列表请求  -peng
export function getCommAllList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findCaseCommAllListByPage',
    method: 'post',
    data: data
  });
}
// 列表请求  -peng
export function getList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findCaseListByPage',
    method: 'post',
    data: data
  });
}
//案件审核记录
export function getCaseExmainRecord(data) {
  return request({
    url: '/batchCase/caseBatchAudits/findCaseAuditByPage',
    method: 'post',
    data: data
  });
}
//案件流转记录 -peng
export function getCasemoveRecord(data) {
  return request({
    url: '/batchCase/caseBatchRecord/findRecordByPage',
    method: 'post',
    data: data
  });
}

//案件送达记录 -peng
export function getCaseService(data) {
  return request({
    url: '/batchCase/caseMessage/findCaseMessageByPage',
    method: 'post',
    data: data
  });
}
// 案件归档  列表
export function getCaseOnFilesList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findCaseListByPage',
    method: 'post',
    data: data
  });
}
// 案件归档  下载
export function downloadOnFiles(data) {
  return request({
    url: '/batchCase/caseBatchInfo/downloadFileByCase',
    method: 'post',
    data: data
  });
}

//案件管理  获取当事人信息 -peng
export function getPartyMaintenance(data) {
  return request({
    url: '/batchCase/casePartymaintain/selectCasePartyByCaseId',
    method: 'post',
    data: data
  });
}
//案件管理  新增当事人信息 -peng
export function addPartyMaintenance(data) {
  return request({
    url: '/batchCase/casePartymaintain/addPartyByCaseId',
    method: 'post',
    data: data
  });
}
//案件管理  修改当事人信息 -peng
export function updatePartyMaintenance(data) {
  return request({
    url: '/batchCase/casePartymaintain/updatePartyByCaseId',
    method: 'post',
    data: data
  });
}
//案件管理  当事人材料上传接口 -peng
export function partyUploadFiles(data) {
  return '/batchCase/fileUpload/uploadFile';
}
//案件管理  当事人材料删除接口 -peng
export function deletePartyFile(data) {
  return request({
    url: '/batchCase/casePartymaintain/delPartyFileById',
    method: 'post',
    data: data
  });
}
//案件管理   补充材料 提交人列表
export function getsubmitterList(data) {
  return request({
    url: '/batchCase/casePartymaintain/getCasePartyInfo',
    method: 'post',
    data: data
  });
}
//案件管理   确定补充材料
export function addSupplementMaterial(data) {
  return request({
    url: '/batchCase/casePartymaintain/addCasePartyProof',
    method: 'post',
    data: data
  });
}

//（行使权利）列表页  -peng
export function getCasePower(data) {
  return request({
    url: '/batchCase/caseExercisePower/listCaseExercisePower',
    method: 'post',
    data: data
  });
}

// 行使权利详情 -peng
export function getCasePowerDetail(data) {
  return request({
    url: '/batchCase/caseExercisePower/revocationCaseFile',
    method: 'post',
    data: data
  });
}

//行使权利详情页  通过审核/拒绝按钮  -peng
export function passAudit(data) {
  return request({
    url: '/batchCase/caseExercisePower/checkCaseExercisePower',
    method: 'put',
    data: data
  });
}
// 案件流程审核  获取列表
export function getProcessList(data) {
  return request({
    url: '/batchCase/manager/caseReview/findReviewCasePage',
    method: 'post',
    data: data
  });
}

// 案件流程审核  获取列表
export function getCaseReplyListByPage(data) {
  return request({
    url: '/batchCase/caseReply/findCaseReplyListByPage',
    method: 'post',
    data: data
  });
}
// 案件流程审核  处理人列表
export function getDealPeopleList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/selectReviewList',
    method: 'post',
    data: data
  });
}

// 案件流程审核  批量审核
export function batchProcedureByAdopt(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchProcessAdopt',
    method: 'post',
    data: data
  });
}

// 案件流程审核  通过审核
export function procedureByAdopt(data) {
  return request({
    url: '/activiti/tProcessInfo/processEngineByAdopt',
    method: 'post',
    data: data
  });
}

// 案件流程审核  拒绝
export function procedureByRefuse(data) {
  return request({
    url: '/activiti/tProcessInfo/processEngineByRefuse',
    method: 'post',
    data: data
  });
}

// 批量立案送达
export function batchFiling(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchSendRegister',
    method: 'post',
    data: data
  });
}

// 批量处理
export function batchTask(data) {
  return request({
    url: '/batchCase/batchTaskRecord/addData',
    method: 'post',
    data: data
  });
}

// 所有案件（案号）点击详情请求   后面直接参数 -peng
export function getDetail(params) {
  return request({
    url: '/batchCase/caseBatchInfo/caseDetail/' + params,
    method: 'get'
  });
}

// 申请人或者被申请人案件材料
export function getMaterial(data) {
  return request({
    url: '/batchCase/casePartyProof/findProofByPage',
    method: 'post',
    data: data
  });
}

// 查询当事人信息
export function getPartyInfo(params) {
  return request({
    url: '/batchCase/caseParty/findCasePartyById/' + params,
    method: 'get'
  });
}

// 审核证据材料
export function auditProof(data) {
  return request({
    url: '/batchCase/casePartyProof/auditProof',
    method: 'post',
    data: data
  });
}

// 秘书列表
// /batchCase/caseBatchInfo/findSecretaryList   ==>先前接口
export function getSecretaryList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findSecretaryByProcess',
    method: 'post',
    data: data
  });
}

// 选择办案秘书及提交经办意见
export function filingPass(data) {
  return request({
    url: '/batchCase/caseBatchInfo/choiceHandingSecretary',
    method: 'post',
    data: data
  });
}

// 案件受理-补充材料
export function filingSupplyProof(data) {
  return request({
    url: '/batchCase/caseBatchInfo/supplyProof',
    method: 'post',
    data: data
  });
}

// 案件受理-不予立案
export function filingRefuse(data) {
  return request({
    url: '/batchCase/caseBatchInfo/caseRegisterRefuse',
    method: 'post',
    data: data
  });
}

// 查询所属仲裁委的案由列表
export function getReasonList() {
  return request({
    url: '/batchCase/caseBatchInfo/findReasonList',
    method: 'get'
  });
}

// 费用快算
export function computePrice(data) {
  return request({
    url: '/batchCase/caseBatchInfo/computePrice',
    method: 'post',
    data: data
  });
}

// 案件立案受理-更新案由
export function caseAccept(data) {
  return request({
    url: '/batchCase/caseBatchInfo/caseRegisterAccept',
    method: 'post',
    data: data
  });
}

// 生成立案文书
export function createRegisterFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/createRegisterFile/' + params,
    method: 'get'
  });
}

// 配置送达方式
export function addSendService(data) {
  return request({
    url: '/batchCase/caseServiceMethod/addSendService',
    method: 'post',
    data: data
  });
}

// 立案送达
export function sendRegister(data) {
  return request({
    url: '/batchCase/caseBatchInfo/casesProcessAdopt',
    method: 'post',
    data: data
  });
}

// 查询案件已选择仲裁员
export function getChoiceArbitrator(params) {
  return request({
    url: '/batchCase/caseArbitrator/findArbitratorByCaseId/' + params,
    method: 'get'
  });
}

// 查询所属仲裁委的仲裁员列表
export function getArbitratorList(params) {
  return request({
    url: '/batchCase/caseBatchInfo/findArbitratorList',
    method: 'get'
  });
}

// 秘书选择仲裁员
export function choiceArbitrator(data) {
  return request({
    url: '/batchCase/caseArbitrator/secretaryChoiceArbitrator',
    method: 'post',
    data: data
  });
}

// 生成组庭文书
export function createComposeFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/createComposeFile/' + params,
    method: 'get'
  });
}

// 组庭送达
export function sendCompose(params) {
  return request({
    url: '/batchCase/caseBatchInfo/sendCompose/' + params,
    method: 'get'
  });
}

// 批量组庭送达
export function batchSendCompose(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchSendCompose',
    method: 'post',
    data: data
  });
}

// 查询所属仲裁委的仲裁庭列表
export function getCourtList(params) {
  return request({
    url: '/batchCase/caseBatchInfo/findCourtList',
    method: 'get'
  });
}

// 新增开庭地点
export function insertCourtInfo(data) {
  return request({
    url: '/batchCase/caseBatchInfo/insertCourtInfo',
    method: 'post',
    data: data
  });
}

// 设置开庭地点
export function choiceCourtAddress(data) {
  return request({
    url: '/batchCase/caseBatchInfo/choiceCourtAddress',
    method: 'post',
    data: data
  });
}

// 生成开庭文书
export function creatCourtFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/creatCourtFile/' + params,
    method: 'get'
  });
}

// 开庭送达
export function sendCourt(params) {
  return request({
    url: '/batchCase/caseBatchInfo/sendCourt/' + params,
    method: 'get'
  });
}

// 批量开庭送达
export function batchSendCourt(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchSendCourt',
    method: 'post',
    data: data
  });
}

// 生成裁决书
export function createRuledFile(data) {
  return request({
    url: '/batchCase/caseFileInstrument/getRuledFile',
    method: 'post',
    data: data
  });
}

// 查询裁决书
export function getRuleFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/findRuleFile/' + params,
    method: 'get'
  });
}

// 上传裁决书
// export function uploadRuleFile(data) {
//   return request({
//     url: '/batchCase/fileUpload/uploadRuleFile',
//     method: 'post',
//     data
//   })
// }

// 上传裁决书-deal api
export function uploadRuleFile() {
  return '/batchCase/fileUpload/uploadFile';
}

// 保存裁决书
export function saveRuleFile(data) {
  return request({
    url: '/batchCase/caseFileInstrument/saveRuleFile',
    method: 'post',
    data: data
  });
}

// 保存撤案决定书
export function saveDecisionFile(data) {
  return request({
    url: '/batchCase/caseFileInstrument/saveDecisionFile',
    method: 'post',
    data: data
  });
}

// 生成裁决送达
export function createRuleSendFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/createRuleSendFile/' + params,
    method: 'get'
  });
}

// 裁决送达
export function sendRule(params) {
  return request({
    url: '/batchCase/caseBatchInfo/sendRule/' + params,
    method: 'get'
  });
}

// 批量审核
export function batchSendRule(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchSendRule',
    method: 'post',
    data: data
  });
}

// 批量生成裁决书（批量下载裁决书）
export function batchCreateRule(data) {
  return request({
    url: '/batchCase/caseBatchInfo/batchCreateRule',
    method: 'post',
    data: data
  });
}

// 批量上传裁决书送达
export function batchUploadRule(data) {
  return '/batchCase/fileUpload/batchUploadRule';
}

// 分页查询案件送达记录
export function getCaseMessageList(data) {
  return request({
    url: '/batchCase/caseMessage/findCaseMessageByPage',
    method: 'post',
    data: data
  });
}

// 查看送达记录详情
export function getCaseMessage(params) {
  return request({
    url: '/batchCase/caseMessage/findCaseMessageById/' + params,
    method: 'get'
  });
}

// 重新送达
export function resendCaseEmail(data) {
  return request({
    url: '/batchCase/caseResendMsg/resendCaseEmail',
    method: 'post',
    data: data
  });
}

// 手动确认送达成功
export function confirmCaseMessage(data) {
  return request({
    url: '/batchCase/caseMessage/confirmCaseMessage',
    method: 'post',
    data: data
  });
}

// 分页查询重复案件列表
export function getRepeatList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findRepeatCasePage',
    method: 'post',
    data: data
  });
}

// 查询重复案件对比信息
export function getCaseCompareInfo(params) {
  return request({
    url: '/batchCase/caseBatchInfo/findCaseCompareInfo/' + params,
    method: 'get'
  });
}

// 标记重复案件
export function markRepeatCase(params) {
  return request({
    url: '/batchCase/caseBatchInfo/markRepeatCase/' + params,
    method: 'get'
  });
}

// 可申请转移案件列表
export function findTransferCasePage(data) {
  return request({
    url: '/batchCase/caseTransferLog/findTransferCasePage',
    method: 'post',
    data: data
  });
}

// 申请案件转移
export function applyCaseTransfer(data) {
  return request({
    url: '/batchCase/caseTransferLog/applyCaseTransfer',
    method: 'post',
    data: data
  });
}

// 平台预审数据列表
export function getplatformPreviewList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/complianceList',
    method: 'post',
    data: data
  });
}

// 回避审核列表
export function getevadingAuditList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findAvoidAuditiList',
    method: 'post',
    data: data
  });
}
// 回避审核获取详情
export function getevadingAuditDetail(params) {
  return request({
    url: '/batchCase/caseBatchInfo/avoidMaterial/' + params,
    method: 'get'
  });
}

// 回避审核列表的审核或者拒绝接口
export function evadingAuditHanding(data) {
  return request({
    url: '/batchCase/caseBatchInfo/avoidApplyAuditing',
    method: 'post',
    data: data
  });
}

// 生效证明查询列表
export function getProveList(data) {
  return request({
    url: '/batchCase/caseBatchInfo/findCaseListByPage',
    method: 'post',
    data: data
  });
}

// 生效证明查询列表
export function downLoadProve(data) {
  return request({
    url: '/batchCase/caseFileInstrument/downCaseEffectiveProof',
    method: 'post',
    data: data
  });
}

//仲裁委取证列表
export function getObtainEvidentList(data) {
  return request({
    url: '/batchCase/caseArbitralFiles/findArbitralFilesCaseListByPage',
    method: 'post',
    data: data
  });
}

// 仲裁委取证确认上传材料
export function obtainEvidentUpload(data) {
  return request({
    url: '/batchCase/caseArbitralFiles/addFiles',
    method: 'post',
    data: data
  });
}
// 仲裁委取证批量上传材料
export function obtainEvidentBatchUpload(data) {
  return request({
    url: 'batchCase/caseArbitralFiles/addBatchFiles',
    method: 'post',
    data: data
  });
}
//查询某个取证材料
export function checkEvidentMaterial(data) {
  return request({
    url: '/batchCase/caseArbitralFiles/selectArbitralFilesByCaseId',
    method: 'post',
    data: data
  });
}
//仲裁委取证确认送达
export function sendEvident(data) {
  return request({
    url: '/batchCase/caseArbitralFiles/sendFiles',
    method: 'post',
    data: data
  });
}
//申请人材料列表
export function supplyMaterialList(data) {
  return request({
    url: '/batchCase/caseAddProof/findAddCaseListByPage',
    method: 'post',
    data: data
  });
}
//申请人材料列表
export function findResCaseByPage(data) {
  return request({
    url: '/batchCase/caseAddProof/findResCaseByPage',
    method: 'post',
    data: data
  });
}

//申请人材料 材料列表
export function findResCaseProof(data) {
  return request({
    url: '/batchCase/caseAddProof/findResCaseProof',
    method: 'post',
    data: data
  });
}

//申请人材料 通过
export function supplyMaterialAdopt(data) {
  return request({
    url: '/batchCase/caseAddProof/proofAdopt',
    method: 'post',
    data: data
  });
}
//申请人材料 拒绝
export function supplyMaterialReject(data) {
  return request({
    url: '/batchCase/caseAddProof/proofRefuse',
    method: 'post',
    data: data
  });
}

//申请人材料 材料列表
export function supplyMaterialSigleList(data) {
  return request({
    url: '/batchCase/caseAddProof/findAddCaseProof',
    method: 'post',
    data: data
  });
}
//获取缴费费用
export function getCasePayInfo(data) {
  return request({
    url: '/batchCase/caseBatchInfo/getCasePayInfo',
    method: 'post',
    data: data
  });
}

//获取缴费费用
export function reCreatePayBook(data) {
  return request({
    url: '/batchCase/caseBatchInfo/caseRegisterUInfo',
    method: 'post',
    data: data
  });
}

//送达缴费通知
export function sendRegisterPayBook(data) {
  return request({
    url: '/batchCase/caseBatchInfo/sendRegisterPayBook',
    method: 'post',
    data: data
  });
}
//查询缴费信息
export function selectRegisterIsPayInfo(data) {
  return request({
    url: '/batchCase/caseRegisterPayLog/selectRegisterIsPayInfo',
    method: 'post',
    data: data
  });
}

//仲裁员签名声明书
export function signArbitrationNoticeFiles(data) {
  return request({
    url: '/batchCase/caseFileInstrument/signArbitrationNoticeFiles',
    method: 'post',
    data: data
  });
}
export function findCaseCourtListByPage(data) {
  return request({
    url: '/batchCase/caseArbitrator/findCaseCourtListByPage',
    method: 'post',
    data: data
  });
}
export function findCaseReplyInfo(data) {
  return request({
    url: '/batchCase/caseReply/findCaseReplyInfo',
    method: 'post',
    data: data
  });
}
// 分页查询待审核的变更仲裁请求列表
export function findArbClaimChangePage(data) {
  return request({
    url: '/batchCase/caseArbClaimChange/findArbClaimChangePage',
    method: 'post',
    data: data
  });
}

//查询变更仲裁请求详情
export function findArbClaimChange(params) {
  return request({
    url: '/batchCase/caseArbClaimChange/findArbClaimChange/' + params,
    method: 'get'
  });
}

// 通过变更请求（废弃）
export function approvalArbClaimChange(data) {
  return request({
    url: '/batchCase/caseArbClaimChange/approvalArbClaimChange',
    method: 'post',
    data: data
  });
}

// 拒绝变更请求（废弃）
export function rejectionArbClaimChange(data) {
  return request({
    url: '/batchCase/caseArbClaimChange/rejectionArbClaimChange',
    method: 'post',
    data: data
  });
}

// 生成变更仲裁请求通知
export function createClaimChangeFile(data) {
  return request({
    url: '/batchCase/caseFileInstrument/createClaimChangeFile',
    method: 'post',
    data: data
  });
}

// 变更仲裁请求通知送达
export function sendClaimChangeFile(data) {
  return request({
    url: '/batchCase/caseBatchInfo/sendClaimChangeFile',
    method: 'post',
    data: data
  });
}

// 上传庭审笔录
export function addTrialRecord(data) {
  return request({
    url: '/batchCase/caseFileInstrument/addTrialRecord',
    method: 'post',
    data: data
  });
}

//查询庭审笔录
export function findTrialRecord(params) {
  return request({
    url: '/batchCase/caseFileInstrument/findTrialRecord/' + params,
    method: 'get'
  });
}

//电子签章验证
export function signatureVerify(params) {
  return request({
    url: '/batchCase/casePartyProof/signatureVerify/' + params,
    method: 'get'
  });
}

// 查询撤案列表
export function findRevokeCasePage(data) {
  return request({
    url: '/batchCase/caseRevoke/findRevokeCasePage',
    method: 'post',
    data: data
  });
}

//查询撤案信息
export function findRevokeInfo(params) {
  return request({
    url: '/batchCase/caseRevoke/findRevokeInfo/' + params,
    method: 'get'
  });
}

// 仲裁委提交撤案
export function submitRevoke(data) {
  return request({
    url: '/batchCase/caseRevoke/submitRevoke',
    method: 'post',
    data: data
  });
}

//生成拒绝撤案文书
export function creatRefuseWithdrawFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/creatRefuseWithdrawFile/' + params,
    method: 'get'
  });
}

// 拒绝撤案送达
export function sendRefuseWithdraw(data) {
  return request({
    url: '/batchCase/caseBatchInfo/sendRefuseWithdraw',
    method: 'post',
    data: data
  });
}

//生成撤案文书
export function creatWithdrawFile(params) {
  return request({
    url: '/batchCase/caseFileInstrument/creatWithdrawFile/' + params,
    method: 'get'
  });
}

// 撤案送达
export function sendWithdraw(data) {
  return request({
    url: '/batchCase/caseBatchInfo/sendWithdraw',
    method: 'post',
    data: data
  });
}
// 列表请求  -peng
export function getPayLogList(data) {
  return request({
    url: '/batchCase/caseRegisterPayLog/findPayCaseListByPage',
    method: 'post',
    data: data
  });
}